type OptionsParam = {
    minDecimals?: number;
    maxDecimals?: number;
    currency?: 'USD' | '';
    useGrouping?: boolean;
};

const formatUSD = (
    value: number | string,
    options: OptionsParam = {
        minDecimals: 0,
        maxDecimals: 2,
        currency: 'USD',
        useGrouping: true,
    }
): string => {
    let {
        minDecimals = 0,
        maxDecimals = 2,
        currency = 'USD',
        useGrouping = true,
    } = options;

    if (!value && value !== 0) {
        console.error('formatUSD: Value is not defined');
        value = 0;
    }

    if (isNaN(+value)) {
        console.error('formatUSD: Value is not a number');
        value = 0;
    }

    if (maxDecimals < minDecimals) {
        maxDecimals = minDecimals;
    }

    // add currency
    return (+value).toLocaleString('en-US', {
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: maxDecimals,
        ...(currency && { style: 'currency', currency }),
        useGrouping,
    });
};

export default formatUSD;
